'use client';

import { appendCampaignParamsToUrl } from '@/lib/persistCampaignParams';
import { WebLink } from '@/lib/WebLinks';
import { useLayoutEffect, useState, type AnchorHTMLAttributes, type MouseEvent, type ReactNode } from 'react';

export function isUrunlerListingHref(href: string): boolean {
  try {
    const url = new URL(href, 'https://hizlicicek.com');
    const path = url.pathname.replace(/\/+$/, '') || '/';
    if (path !== WebLink.PRODUCTS) return false;
    return !url.searchParams.has('q');
  } catch {
    return false;
  }
}

function goToListingDocument(href: string, event: MouseEvent<HTMLAnchorElement>) {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
    return;
  }
  event.preventDefault();
  window.location.assign(appendCampaignParamsToUrl(href));
}

export function UrunlerListingAnchor({
  href,
  children,
  onClick,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string; children: ReactNode }) {
  const [resolved, setResolved] = useState(href);
  useLayoutEffect(() => {
    setResolved(appendCampaignParamsToUrl(href));
  }, [href]);
  return (
    <a
      href={resolved}
      {...rest}
      onClick={(event) => {
        onClick?.(event);
        if (event.defaultPrevented) return;
        goToListingDocument(href, event);
      }}
    >
      {children}
    </a>
  );
}
